import {graphql, useStaticQuery} from "gatsby";

export const useSideNavigationQuery = () => {
  return useStaticQuery(graphql`
    query TreeStructure {
      allContentfulComponentTreeStructure {
        edges {
          node {
            type
            parentItems {
              ... on ContentfulTemplatePageFinancial {
                id
                slug
                pageTitle
              }
               ... on ContentfulTemplatePageGovernance {
                id
                slug
                pageTitle
              }
              ... on ContentfulPageStockInformation {
                id
                slug
                pageTitle
              }
              ... on ContentfulPageRequestDocument {
                id
                slug
                pageTitle
              }
              ... on ContentfulTemplateProduct {
                id
                slug
                title
                shortTitle
                descriptionHtml {
                  content
                }
                childrenProducts {
                  title
                  shortTitle
                  slug
                }
              }
            }
          }
        }
      }
    }
  `)
}